// components/sessions/ChatsTab.js
import React from 'react';
import SessionsTab from './SessionsTab';

const ChatsTab = (props) => {
  const chatConfig = {
    title: 'Le mie Chat',
    emptyMessage: 'Non hai ancora nessuna chat. Inizia una nuova conversazione!',
    primaryAction: 'Nuova Chat',
    filters: {
      showLeaderDrive: false,
      defaultTimeRange: 'week'
    }
  };
  
  return (
    <SessionsTab 
      {...props} 
      sessionType="chat"
      tabConfig={chatConfig}
    />
  );
};

export default ChatsTab;